import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  Filler,
  Tooltip,
  Legend
} from 'chart.js'

Chart.register(LineController, LineElement, PointElement, LinearScale, Title, CategoryScale, Filler, Tooltip, Legend)

export default class extends Controller {
  static values = {
    serial: String
  }

  async connect() {
    const ctx = this.element.getContext("2d")
    const serial = this.serialValue

    console.log('Forecast chart connecting for serial:', serial)

    // Destruir chart anterior se existir
    if (this.chart) {
      console.log('Destroying previous chart')
      this.chart.destroy()
    }

    try {
      // Buscar dados reais da API
      console.log('Fetching data for serial:', serial)
      const response = await fetch(`/dashboard/forecast_chart.json?serial=${serial}`)
      const data = await response.json()
      console.log('Data received:', data)

      // Se não houver dados, mostrar gráfico vazio
      if (!data.labels || data.labels.length === 0) {
        this.renderEmptyChart(ctx)
        return
      }

      // Calcular máximo de wind speed
      const maxWindSpeed = Math.max(...data.wind_speed)
      const windSpeedMax = Math.max(20, maxWindSpeed)

      const chartData = {
        labels: data.labels,
        datasets: [
          {
            label: 'Power (kW)',
            data: data.power,
            borderColor: 'rgb(255, 0, 0)',
            backgroundColor: 'rgba(255, 0, 0, 0.1)',
            tension: 0.1,
            fill: false
          },
          {
            label: 'Wind Speed (m/s)',
            data: data.wind_speed,
            borderColor: 'blue',
            backgroundColor: 'transparent',
            tension: 0.1,
            yAxisID: 'y1'
          }
        ]
      }

      const config = {
        type: 'line',
        data: chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: 'index',
            intersect: false,
          },
          plugins: {
            legend: {
              position: 'top'
            },
            tooltip: {
              callbacks: {
                title: function(context) {
                  // Mostrar data/hora completa no título do tooltip
                  const index = context[0].dataIndex
                  return data.full_labels[index]
                },
                afterLabel: function(context) {
                  if (context.datasetIndex === 1) {
                    const idx = context.dataIndex
                    return [
                      `Gust: ${data.gust_speed[idx]} m/s`,
                      `Direction: ${data.direction[idx]}°`,
                      `Temp: ${data.temp[idx]}°C`
                    ]
                  }
                }
              }
            }
          },
          scales: {
            x: {
              grid: {
                display: false
              }
            },
            y: {
              type: 'linear',
              display: true,
              position: 'left',
              title: {
                display: true,
                text: 'Power (kW)'
              },
              grid: {
                display: false
              }
            },
            y1: {
              type: 'linear',
              display: true,
              position: 'right',
              title: {
                display: true,
                text: 'Wind Speed (m/s)'
              },
              min: 0,
              max: windSpeedMax,
              grid: {
                drawOnChartArea: false,
              }
            }
          }
        }
      }

      this.chart = new Chart(ctx, config)
    } catch (error) {
      console.error('Error loading forecast data:', error)
      this.renderEmptyChart(ctx)
    }
  }

  disconnect() {
    // Destruir chart ao desconectar controller
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  renderEmptyChart(ctx) {
    const emptyData = {
      labels: ['No data available'],
      datasets: [{
        label: 'No forecast data',
        data: [0],
        borderColor: 'gray',
        backgroundColor: 'transparent'
      }]
    }

    this.chart = new Chart(ctx, {
      type: 'line',
      data: emptyData,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false }
        }
      }
    })
  }
}


